module.exports = "/assets/3078d3f47e4c9b0b3dc08e499b30bcfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9U.png
// module id = 1173
// module chunks = 0